import { TokenOption } from "./types";
import { TokenSelect } from "./TokenSelect";

interface TokenInputProps {
  label: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  token: TokenOption;
  onTokenSelect?: (token: TokenOption) => void;
  availableTokens?: TokenOption[];
  balanceText?: string;
  readOnly?: boolean;
  orientation?: "left" | "right";
}

export function CustomTokenInput({
  label,
  value,
  onChange,
  token,
  onTokenSelect,
  availableTokens = [],
  balanceText,
  readOnly = false,
  orientation = "left",
}: TokenInputProps) {
  const inputField = (
    <input
      type='text'
      value={value}
      onChange={onChange}
      placeholder='0'
      className={`flex-1 w-full p-4 text-black text-xl font-regular focus:outline-none ${orientation === "right" ? "text-right" : ""}`}
      readOnly={readOnly}
    />
  );

  return (
    <div>
      <p className='text-black mb-2 text-left text-xs'>{label}</p>
      <div className='border border-gray-200 rounded-lg overflow-hidden'>
        <div className='flex items-center'>
          {orientation === "left" ? (
            <>
              {inputField}
              <TokenSelect token={token} onTokenSelect={onTokenSelect} availableTokens={availableTokens} triggerClassName='justify-end' />
            </>
          ) : (
            <>
              <TokenSelect token={token} onTokenSelect={onTokenSelect} availableTokens={availableTokens} triggerClassName='justify-start' />
              {inputField}
            </>
          )}
        </div>
        {balanceText && (
          <div className='text-left border-t border-gray-200 px-4 py-3 bg-gray-50'>
            <p className='text-black text-sm'>{balanceText}</p>
          </div>
        )}
      </div>
    </div>
  );
}
